import { render, staticRenderFns } from "./CtaGhost.vue?vue&type=template&id=8fd6798c&scoped=true"
import script from "./CtaGhost.vue?vue&type=script&lang=js"
export * from "./CtaGhost.vue?vue&type=script&lang=js"
import style0 from "./CtaGhost.vue?vue&type=style&index=0&id=8fd6798c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd6798c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fd6798c')) {
      api.createRecord('8fd6798c', component.options)
    } else {
      api.reload('8fd6798c', component.options)
    }
    module.hot.accept("./CtaGhost.vue?vue&type=template&id=8fd6798c&scoped=true", function () {
      api.rerender('8fd6798c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CtaGhost.vue"
export default component.exports